var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClienttagsBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26.5191497px",
    height: "26.519116px",
    viewBox: "0 0 26.5191497 26.519116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:tag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-Light-New-Icons",
    transform: "translate(-16, -483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:tag",
    transform: "translate(13, 480)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(4, 4)",
    stroke: "#192340",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75733333,0 L3,0 C1.34314575,0 0,1.34314575 0,3 L0,8.75733333 C0,9.55333333 0.316,10.3173333 0.878666667,10.8786667 L13.6533333,23.6533333 C14.5853333,24.5853333 16.0266667,24.816 17.1293333,24.0933333 C19.904802,22.2755199 22.2755199,19.904802 24.0933333,17.1293333 C24.816,16.0266667 24.5853333,14.5853333 23.6533333,13.6533333 L10.88,0.88 C10.3172774,0.31657665 9.55363895,0 8.75733333,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 4 4.01066667 4 4.01066667 4.01066667 4 4.01066667"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClienttagsBlack);
export default __webpack_public_path__ + "static/media/clienttags-black.67e3e1086b24a0b21d399e10d8647494.svg";
export { ForwardRef as ReactComponent };